import { StorageTypes } from '@morningstar/shared/base/storage-service';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { TokenLogin } from './token-login/token-login';
import { TokenService } from '@morningstar/shared/auth';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Token } from '@morningstar/shared/auth';
import { Login } from '@morningstar/shared/auth';
import { GenericErrorHandler } from '@morningstar/shared/base/error-handler';
import { environment } from '@morningstar/shared/environment';
import { ResetPassword } from './reset-password/reset-password';

@Injectable()
export class LoginService {

  constructor(private httpClient: HttpClient, private tokenService: TokenService, private storageService: StorageService) { }

  login(login: Login): Observable<Token> {
    return this.httpClient.post<Token>(`${environment.spaceGeekUrl}${environment.api.login.login}`, login)
                           .pipe(
                             tap((token: Token) => {
                               this.tokenService.storeToken(token);
                               this.storageService.setItem(StorageTypes.location, this.tokenService.getDefaultLocation());
                             }),
                             catchError(GenericErrorHandler.handleError<Token>('login'))
                           );
  }

  tokenLogin(q: string): Observable<TokenLogin> {
    return this.httpClient.post<TokenLogin>(`${environment.spaceGeekUrl}${environment.api.login.tokenLogin}`, { token: q })
                           .pipe(
                             tap((token: TokenLogin) => {
                              this.tokenService.storeToken(token.token);
                              this.storageService.setItem(StorageTypes.location, token.location);
                              if (token.client) {
                                this.storageService.setItem(StorageTypes.client, token.client);
                              }
                             }),
                             catchError(GenericErrorHandler.handleError<TokenLogin>('login'))
                           );
  }

  sendResetLink(username: string): Observable<any> {
    return this.httpClient.post(`${environment.spaceGeekUrl}${environment.api.login.forgotPassword}`, { email: username })
                          .pipe(catchError(GenericErrorHandler.handleError('sendResetLink')));
  }

  resetPassword(model: ResetPassword): Observable<any> {
    return this.httpClient.post(`${environment.spaceGeekUrl}${environment.api.login.resetPassword}`, model)
                          .pipe(catchError(GenericErrorHandler.handleError('resetPassword')));
  }
}
